import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/smart-working')({ component: SmartWorkingLayout });

/** Layout della sezione Smart Working: index (planner) e /approvals nidificati. */
function SmartWorkingLayout() {
  return <Outlet />;
}
